module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAMCAQAAADb0hWEAAAAGElEQVR42mPo/k8O7CpjGNU4qpE8jeQCAP821CpzfH6BAAAAAElFTkSuQmCC"